export default __webpack_public_path__ + "static/media/isa2.1cce1b15.jpg";